import React from "react";
import { Input, AutoComplete, Icon, Select } from "antd";
import {searchOrderIdForSelector} from "api/api";
import { displayGenericError } from "common/notifications";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";

class OrderSelectionComponent extends React.Component {
    state = {
        dataSource: [],
        searchResults: [],
        selection: null
    };

    searchTimerID = null;
    onChange = value =>{
        this.props.onChange(value)
    }
    onSelect = value => {
        let selectedOrder = null;
        for (let i = 0; i < this.state.searchResults.length; i++) {
            if (this.state.searchResults[i].orderId == value) {
                selectedOrder = this.state.searchResults[i];
                break;
            }
        }
        this.props.onSelected(selectedOrder);
    };

    handleSearch = value => {
        clearTimeout(this.searchTimerID);
        this.searchTimerID = setTimeout(() => {
            searchOrderIdForSelector(value)
                .then(response => {
                    this.setState({
                        searchResults: response,
                        dataSource: response
                    });
                })
                .catch(error => {
                    displayGenericError(error);
                });
        }, 250);
    };

    renderOption = item => {
        return (
            <Select.Option key={item.orderId} text={item.orderId}>
                <span className="searchResult">{item.orderId + " " + item.customerName}</span>
            </Select.Option>
        );
    };

    render() {
        const intl = this.props.useIntl;
        return (
            <div style={this.props.style}>
                <AutoComplete
                    className="global-search"
                    size="large"
                    style={{width: '100%'}}
                    dataSource={this.state.dataSource.map(this.renderOption)}
                    onChange={this.onChange}
                    onSelect={this.onSelect}
                    onSearch={this.handleSearch}
                    optionLabelProp="text"
                >
                    <Input
                        style={{...this.props.style}}
                        placeholder={intl.formatMessage({id: "app.table.orderstable.orderid"})}
                        prefix={<Icon type="search" />}
                    />
                </AutoComplete>
            </div>
        );
    }
}

export default withUseIntl(OrderSelectionComponent);